import LineChart from './LineChart.js';
import BarChart from './BarChart.js';
import AreaChart from './AreaChart.js';
import PieChart from './PieChart.js';
import ScatterChart from './ScatterChart.js';

export const renderers = {
  line: LineChart,
  bar: BarChart,
  area: AreaChart,
  pie: PieChart,
  doughnut: PieChart,
  scatter: ScatterChart,
};
